import { SAlert } from '@avalara/skylab-sdk/react';
import type { Dispatch } from '@avalara/types/actions';
import { useDispatch } from 'react-redux';

import { setShowExistingAccountAlert } from '../../../store/shared-signup';

const ExistingAccountAlert = () => {
  const dispatch = useDispatch<Dispatch>();

  return (
    <SAlert
      className='border-radius-lg show-icon margin-bottom-sm'
      data-ref='buy.offer.existing-account-alert'
      id='buy-offer-existing-account-alert'
      status='error'
      onS-dismiss={() => dispatch(setShowExistingAccountAlert(false))}
    >
      <div>
        <span className='margin-top-none margin-bottom-xs text-sm-strong'>Free trial not available</span>
        <div>
          You already have an Avalara account, so this free trial isn't available. Contact your sales representative to
          add this product.
        </div>
      </div>
    </SAlert>
  );
};

export default ExistingAccountAlert;
